import { Injectable, EventEmitter } from '@angular/core';
import { AppConfigService } from '../../reactive-forms/services/app-config.service';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { Message, ContentType, MessageStatus, RecipientType } from '../../Message';
import { GridRefreshService } from '../../reactive-forms/services/grid.refresh.service';
import { UserInfo } from '../../userInfo';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SignalRHelperService {
  public _hubConnection: HubConnection;
  messageReceived = new EventEmitter<Message>();
  messageStatusUpdate = new EventEmitter<Message>();
  GrpPendingMsgCount = new EventEmitter<Message>();
  SenderPendingMsgCount = new EventEmitter<Message>();
  refreshNotifications = new EventEmitter<Message>();
  public connectionId: string;
  connectionEstablished = new EventEmitter<Boolean>();
  public messages = new Array<Message>();
  public message = new Message();

  constructor(private environment: AppConfigService, private http: HttpClient) {

  }
  public EstablishConnection(){ // just for test pr 
  
      this.createConnection();
      this.registerOnServerEvents();
      this.startConnection();
  }
  private startConnection(): void {
    this._hubConnection
      .start()
      .then(() => {
        console.log('Hub connection started');
        this.connectionEstablished.emit(true);
      })
      .catch(err => {
        console.log(err)
      });
  }
  private createConnection() {

    var SalesmanNo = '';
    var userdata = localStorage.getItem("userinfo");
    if (userdata) {
      var user = JSON.parse(localStorage.getItem("userinfo"));
      SalesmanNo = user.UserCode;
    }

    //var url = this.environment.apiRoot + 'BroadcastHub';
    var url = this.environment.oDataApi +'/ChatHub';
    this._hubConnection = new HubConnectionBuilder()
      .withUrl(url,{
        accessTokenFactory:()=>{
        return localStorage.getItem('ODataToken');
      }})
      .withAutomaticReconnect()
      .build();


  }


  private registerOnServerEvents(): void {
    this._hubConnection.on('ReceiveMessage', (data: any) => {
      this.messageReceived.emit(data);
    });
    this._hubConnection.on('RefreshNotificationNumber', (data: any) => {
      this.refreshNotifications.emit(data);
    });


  }
  sendMessage(message: any) {
    
    this._hubConnection.invoke('SendMessage', message).catch(function (err) {
     // alert('Connection disconnected, please refresh');
      return console.error(err.toString());
    });
  }
  MarkAsRead(subordinateId:string) {
    
    this._hubConnection.invoke('ReadMessage', subordinateId).catch(function (err) {
    //  alert('Connection disconnected, please refresh');
      return console.error(err.toString());
    });
  }
  UpdateMessageStatus(currentSalesmanNo, ServerMsgID, MessageStatus) {
    
    this._hubConnection.invoke('UpdateServerMessagesStatus', ServerMsgID, MessageStatus);
  }
  GetGrpPendingMessageCount(groupID) {
    
    this._hubConnection.invoke('GetPenningGroupMsgsCount', groupID);
  }
  GetSenderPendingMessageCount(senderID) {
    
    this._hubConnection.invoke('GetPenningSenderMsgsCount', senderID);
  }

  public getConnectionId = () => {
    this._hubConnection.invoke('getconnectionid').then(
      (data) => {
        console.log(data);
        this.connectionId = data;
      }

    );
  }
  UploadFile(file: Blob, fileName, SenderID, Salesmaname, RecipientID) {
    
    let fileToUpload = file;
    const formData = new FormData();
    formData.append('file', fileToUpload, fileName);
    this.UploadToServer(formData, fileName, SenderID, Salesmaname, RecipientID);
  }

  UploadToServer(formData, filename, SenderID, Salesmaname, RecipientID) {
    
    this.http.post(this.environment.apiRoot + 'api/Chat/Upload', formData, { reportProgress: true, observe: 'events' })
      .subscribe(event => {
        if (event.type === HttpEventType.Response) {
          this.message = new Message();
          this.message.Content = event.body['dbPath'];
          var ext = filename.substring(filename.lastIndexOf('.'), filename.length);
          if (ext.toLowerCase() == '.pdf' || ext.toLowerCase() == '.txt' || ext.toLowerCase() == '.doc' || ext.toLowerCase() == '.docx' || ext.toLowerCase() == '.xls' || ext.toLowerCase() == '.xlsx')
            this.message.ContentType = ContentType.Document;
          if (this.message.Content) {
            this.message.SenderID = SenderID;
            this.message.SalesmanameE = Salesmaname;
            this.message.SalesmanNameA = Salesmaname;
            this.message.FullStatus = MessageStatus.sent;
            this.message.RecipientType = RecipientType.OneToOne;
            this.message.RecipientID = RecipientID;

            this.message.MsgDateTime = new Date();
            this.messages.push(this.message);
            this.sendMessage(this.message);
          }
        }
      }
      );

  }


}
